<div class="report-modal">
  <span class="report-modal__text">
    {{ data?.message }}
  </span>

  <button
    type="button"
    class="report-modal__btn"
    (click)="close()">
    Entendi
  </button>
</div>
